import React, { useState } from "react";
import { Menu, MenuItem, IconButton, Box } from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import WindowOutlinedIcon from "@mui/icons-material/WindowOutlined";
import CalendarViewMonthOutlinedIcon from "@mui/icons-material/CalendarViewMonthOutlined";

const GridViewDropdown = ({ viewMode, setViewMode, selectedCamera }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  // Get the appropriate icon based on the selected view mode
  const getViewIcon = () => {
    if (viewMode === "list") {
      return <WindowOutlinedIcon style={{ color: "#CE8500" }} />;
    }
    return <CalendarViewMonthOutlinedIcon style={{ color: "#CE8500" }} />;
  };

  return (
    <div>
      {!selectedCamera && (
        <Box>
          <IconButton
            onClick={handleClick}
            style={{
              borderRadius: 12,
              padding: 10,
              backgroundColor: "#fff",
            }}
          >
            {getViewIcon()} {/* Show the selected view icon */}
            <ArrowDropDownIcon style={{ color: "#CE8500" }} />
          </IconButton>
        </Box>
      )}
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        <MenuItem
          onClick={() => {
            setViewMode("list");
            handleClose();
          }}
        >
          <WindowOutlinedIcon style={{ color: "#CE8500", marginRight: 8 }} />
          List View
        </MenuItem>
        <MenuItem
          onClick={() => {
            setViewMode("grid");
            handleClose();
          }}
        >
          <CalendarViewMonthOutlinedIcon
            style={{ color: "#CE8500", marginRight: 8 }}
          />
          Grid View
        </MenuItem>
      </Menu>
    </div>
  );
};

export default GridViewDropdown;
